// Types for Admin Panel

export type ClientGrade = 'A' | 'B' | 'C' | 'T';
export type PaymentType = 'one_time' | 'subscription' | 'one_time_full';

/** Tipo de contrato: individual, duo familiar, familia con hijos, o oferta 2x1 (dos contratos vinculados) */
export type ContractType = 'individual' | 'duo' | 'family' | 'linked';

export interface CreateHiringRequest {
  contract_template: string; // Template del contrato (requerido)
  service_name: string; // Nombre del servicio
  service_description?: string; // Descripción del servicio
  amount?: number; // Monto en centavos
  currency?: string; // Moneda
  grade: ClientGrade; // Grado del cliente ("A", "B", "C", o "T" para testing)
  payment_type?: PaymentType; // Tipo de pago: "one_time" o "subscription" (default: "one_time")
  expires_in_days?: number; // Días de expiración
  notes?: string; // Notas adicionales
  // Asociación con contacto del CRM
  contact_id?: string; // ID del contacto en el CRM (UUID) - opcional
  // Datos del cliente (información de contacto principal)
  client_name: string; // Nombre completo del cliente (requerido)
  client_email: string; // Email del cliente (requerido)
  client_nationality?: string; // Nacionalidad del cliente
  // Datos del cliente (información adicional del documento)
  client_passport?: string; // Pasaporte del cliente
  client_nie?: string; // NIE del cliente
  client_address?: string; // Dirección del cliente
  client_city?: string; // Ciudad del cliente
  client_province?: string; // Provincia del cliente
  client_postal_code?: string; // Código postal del cliente
  // Pago manual (si el admin lo marca)
  manual_payment_confirmed?: boolean; // Si el pago ya fue realizado manualmente
  manual_payment_note?: string; // Nota sobre el pago manual
  manual_payment_method?: string; // Método de pago manual
}

export interface HiringCodeResponse {
  id: string; // payment-uuid
  hiring_code: string;
  user_name: string;
  user_email: string;
  service_name: string;
  service_description: string;
  amount: number;
  currency: string;
  status: 'pending' | 'paid' | 'completed';
  kyc_status: null | 'pending' | 'verified' | 'failed';
  expires_at: string;
  short_url: string;
  grade: ClientGrade;
  client_passport?: string;
  client_nie?: string;
  client_address?: string;
  client_city?: string;
}

/** Precios por grado (legacy; usar CONTRACT_TYPE_PRICING cuando exista contract_type) */
export const GRADE_PRICING = {
  A: 400,
  B: 400,
  C: 600,
  T: 1, // Testing - Solo 1€ para pruebas internas
} as const;

/** Precios suscripción por grado (legacy) */
export const GRADE_PRICING_SUBSCRIPTION = {
  A: 480, // 10 pagos de 48€
  B: 480, // 10 pagos de 48€
  C: 680, // 10 pagos de 68€
  T: 1, // Testing - Solo 1€ para pruebas internas
} as const;

/** Precios por tipo de contrato (EUR). individual/duo/family: total; linked: precio POR contrato. */
export const CONTRACT_TYPE_PRICING = {
  individual: { one_time: 400, subscription: 480, monthly: 48 },
  duo: { one_time: 600, subscription: 680, monthly: 68 },
  family: { one_time: 600, subscription: 680, monthly: 68 },
  linked: { one_time: 300, subscription: 340, monthly: 34 },
} as const;

/** Descripción de la calificación del expediente. El precio no depende de la Nota sino del tipo de contrato. */
export const GRADE_DESCRIPTIONS = {
  A: 'Excelente - Alta probabilidad de éxito',
  B: 'Bueno - Probabilidad buena de éxito',
  C: 'Complejo - Requiere estudio adicional',
  T: 'Testing - Solo para pruebas internas (1€)',
} as const;

/** Etiquetas para tipo de contrato (UI) */
export const CONTRACT_TYPE_LABELS: Record<ContractType, string> = {
  individual: 'Individual',
  duo: 'Pareja / Duo',
  family: 'Unidad familiar',
  linked: 'Oferta 2x1',
};

